<template>
  <el-dialog
      v-el-drag-dialog
      :visible.sync="dialogVisible"
      append-to-body
      title="地址变更单"
      width="1200px"
      top="10vh"
      @close="$reset('form')">
    <el-form ref="form" :model="form" :rules="ruleValidate" label-width="100px">
      <el-row>
        <el-col :span="5">
          <el-form-item label="销售区域">
            <el-input v-model="form.salesArea" :disabled="!edit"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="销售员">
            <el-input v-model="form.salesPersonName" :disabled="!edit"/>
          </el-form-item>
        </el-col>
        <el-col :span="8">
          <el-form-item label="客户名称" prop="customerName">
            <el-input v-model="form.customerName" placeholder="请输入" clearable>
              <el-button
                  slot="append"
                  icon="el-icon-search"
                  style="margin-left: 2%;"
                  @click="$refs.selectCustomer.open()">
                选择
              </el-button>
            </el-input>
            <customer-select ref="selectCustomer" @select="selectCustomer"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="大小包装">
            <el-select v-model="form.maxMinPack" placeholder="请选择大小包装" :disabled="!edit">
              <el-option value="大包装" label="大包装"/>
              <el-option value="小包装" label="小包装"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col
            :span="5">
          <el-form-item label="工作联系单">
            <el-input v-model="form.contactOrder" :disabled="!edit"/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="创建时间">
            <el-input v-model="form.createTime" disabled/>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="物流公司">
            <el-select v-model="form.trackCompany" placeholder="请选择物流公司" :disabled="!edit">
              <el-option value="跨越速运" label="跨越速运"/>
              <el-option value="顺丰速运" label="顺丰速运"/>
              <el-option value="中通快递" label="中通快递"/>
              <el-option value="供应商直发" label="供应商直发"/>
            </el-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item label="物流方式">
            <el-select v-model="form.trackType" placeholder="请选择物流方式" :disabled="!edit">
              <el-option label="跨越当天达" value="当天达"/>
              <el-option label="跨越省内次日" value="省内次日"/>
              <el-option label="跨越次日达" value="次日达"/>
              <el-option label="跨越陆运件" value="陆运件"/>
              <el-option label="跨越隔日达" value="隔日达"/>
              <el-option label="跨越同城次日" value="同城次日"/>
              <el-option label="顺丰标快" value="顺丰标快"/>
              <el-option label="中通快递" value="标准"/>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
      <el-form-item label="变更内容">
        <el-input v-model="form.mainContent" type="textarea" placeholder="请输入"/>
      </el-form-item>
    </el-form>
    <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
      <div slot="toolbar">
        未匹配PC号对应发货单
      </div>
      <el-table :data="form.shipmentProcessVOList" border>
        <el-table-column
            prop="factoryNo"
            align="center"
            label="出厂编号"
            width="150"/>
        <el-table-column
            prop="invoiceNo"
            align="center"
            label="发货单号"
            width="120"/>
        <el-table-column
            prop="completeEndState"
            align="center"
            label="发运状态"
            width="120"/>
        <el-table-column
            prop="deliveryDate"
            align="center"
            label="交期"
            width="120"/>
        <el-table-column
            prop="shippingAddress"
            align="center"
            label="发货单地址"
            width="400"/>
        <el-table-column
            prop="weight"
            align="center"
            label="重量"
            width="120"/>
        <el-table-column
            prop="carNo"
            align="center"
            label="快递单号"
            width="200"/>
        <el-table-column
            label="操作"
            align="center"
            class-name="vm-table_operate"
            fixed="right"
            width="140px">
          <template slot-scope="scope">
            <el-button type="primary" @click="apply(scope.row)">应用</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <div style="border-bottom:1px solid #ddd;margin-bottom: 10px;padding-bottom: 5px;font-size: 16px;margin-top: 20px">
      <div slot="toolbar">
        地址更改明细
        <el-button type="primary" style="margin-bottom: 10px" @click="addRow">
          新增
        </el-button>
        <el-button type="primary" style="margin-bottom: 10px" :loading="updateLoading" @click="updateVO">
          明细更新
        </el-button>
      </div>
    </div>
    <el-table :data="form.details" border>
      <el-table-column
          prop="factoryNo"
          align="center"
          label="出厂编号"
          width="150">
        <template slot-scope="scope">
          <el-input v-model="scope.row.factoryNo" :disabled="!edit || scope.row.status===1"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="invoiceNo"
          align="center"
          label="发货单号"
          width="120">
        <template slot-scope="scope">
          <el-input v-model="scope.row.invoiceNo" :disabled="!edit || scope.row.status===1"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="shippingAddress"
          align="center"
          label="发货单地址"
          width="250">
        <template slot-scope="scope">
          <el-input v-model="scope.row.shippingAddress" :disabled="!edit || scope.row.status===1"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="weight"
          align="center"
          label="重量"
          width="120">
        <template slot-scope="scope">
          <el-input v-model="scope.row.weight" :disabled="!edit || scope.row.status===1"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="oldProvinceCity"
          align="center"
          label="原地址省市区"
          width="200">
        <template slot-scope="scope">
          <vm-district-select v-model="scope.row.oldAreaId" :disabled="!edit || scope.row.status===1"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="oldAddressDetail"
          align="center"
          label="原详细地址"
          width="240"
          show-overflow-tooltip>
        <template slot-scope="scope">
          <el-input v-model="scope.row.oldAddressDetail" :disabled="!edit || scope.row.status===1"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="oldPrice"
          align="center"
          label="原地址运费"
          width="120">
        <template slot-scope="scope">
          <el-input v-model="scope.row.oldPrice" :disabled="!edit || scope.row.status===1"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="newProvinceCity"
          align="center"
          label="新地址省市区"
          width="200">
        <template slot-scope="scope">
          <vm-district-select v-model="scope.row.newAreaId" :disabled="!edit || scope.row.status===1"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="newAddressDetail"
          align="center"
          label="新详细地址"
          width="200"
          show-overflow-tooltip>
        <template slot-scope="scope">
          <el-input v-model="scope.row.newAddressDetail" :disabled="!edit || scope.row.status===1"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="newPrice"
          align="center"
          label="新地址运费"
          width="120">
        <template slot-scope="scope">
          <el-input v-model="scope.row.newPrice" :disabled="!edit || scope.row.status===1"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="payedPrice"
          align="center"
          label="已收费用"
          width="120">
        <template slot-scope="scope">
          <el-input
              v-model="scope.row.payedPrice"
              :disabled="!edit || scope.row.status===1"
              @change="updateRestPrice(scope.row)"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="restPrice"
          align="center"
          label="需要补的费用"
          width="120">
        <template slot-scope="scope">
          <el-input v-model="scope.row.restPrice" :disabled="!edit || scope.row.status===1"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="trackingNumber"
          align="center"
          label="快递单号"
          width="200">
        <template slot-scope="scope">
          <el-input v-model="scope.row.trackingNumber" :disabled="!edit || scope.row.status===1"/>
        </template>
      </el-table-column>
      <el-table-column
          prop="note"
          align="center"
          label="备注"
          width="100">
        <template slot-scope="scope">
          <el-input v-model="scope.row.note" :disabled="!edit || scope.row.status===1"/>
        </template>
      </el-table-column>
      <el-table-column
          label="操作"
          align="center"
          class-name="vm-table_operate"
          fixed="right"
          width="240px">
        <template slot-scope="scope">
          <el-button v-if="completeAuth" type="primary" :disabled="scope.row.status === 1" @click="complete(scope.row)">
            结单
          </el-button>
          <el-button type="primary" :disabled="scope.row.status===1" @click="setPrice(scope.row)">计算运费</el-button>
          <el-button type="danger" :disabled="scope.row.status===1" @click="oneDelete(scope.$index,scope.row)">
            删除
          </el-button>
        </template>
      </el-table-column>
    </el-table>
    <span v-if="edit" slot="footer" class="dialog-footer">
      <el-button @click="dialogVisible = false">取 消</el-button>
      <el-button type="primary" :loading="submitLoading" @click="saveHandle">保存</el-button>
    </span>
  </el-dialog>
</template>

<script>
  import CustomerSelect from "@/views/information/Customer/CustomerSelect";
  import VmDistrictSelect from "@/components/VmDistrictSelect";

  export default {
    components: {CustomerSelect, VmDistrictSelect},
    data() {
      return {
        completeAuth: this.$auth(398),
        updateLoading: false,
        pkid: "",
        activeName: "deliverySlipInfo", // 当前标签页
        dialogVisible: false,
        submitLoading: false,
        edit: 0,
        form: {
          trackCompany: "",
          newPrice: "",
          customerName: "",
          createTime: "",
          mainContent: "",
          salesArea: "",
          note: "",
          trackType: "",
          oldPrice: "",
          salesPersonName: "",
          contactOrder: "",
          details: [],
        },
        ruleValidate: {},
      };
    },

    methods: {
      open(pkid, edit) {
        this.pkid = pkid;
        this.edit = edit;
        if (pkid) {
          this.getData();
        } else {
          this.form;
        }
        this.dialogVisible = true;
      },


      //编辑查详情
      getData() {
        this.$http.get("basic", `ChangeAddress/${this.pkid}`).then((resp) => {
          this.$nextTick(() => {
            for (let i = 0; i < resp.details.length; i++) {
              this.form.details.push({
                newAreaId: 0,
                oldAreaId: 0,
              });
            }

            setTimeout(() => {
              this.form = resp;
            }, 500);

          });

        });
      },

      oneDelete(index) {
        this.form.details.splice(index, 1);
      },

      // 保存
      saveHandle() {
        this.submitLoading = true;
        if (!this.pkid) {
          this.$http
            .post("basic", "ChangeAddress", this.form)
            .then(() => {
              this.submitLoading = false;
              this.dialogVisible = false;
              this.$emit("save-success");
              this.$message.success("保存成功");
            })
            .catch(() => {
              this.submitLoading = false;
            });
        } else {
          this.$http
            .post("basic", "ChangeAddress/update", this.form)
            .then(() => {
              this.submitLoading = false;
              this.dialogVisible = false;
              this.$emit("save-success");
              this.$message.success("编辑成功");
            })
            .catch(() => {
              this.submitLoading = false;
            });
        }
      },

      selectCustomer(row) {
        console.log(row);
        this.form.customerName = row.customerName;
        this.form.customerNo = row.outerNo;
      },

      addRow() {
        const item = {
          weight: 0,
          oldPrice: 0,
          newPrice: 0,
          payedPrice: 0,
          restPrice: 0,
        };
        this.form.details.push(item);
      },

      setPrice(row) {
        console.log(this.form);
        console.log(row);
        if (this.form.trackCompany === null || this.form.trackCompany === "") {
          this.$message.error("请先选择快递公司");
        } else if (this.form.trackType === null || this.form.trackType === "") {
          this.$message.error("请先选择物流方式");
        } else if (row.weight === null || row.weight === 0) {
          this.$message.error("请先输入重量");
        } else {
          row.trackCompany = this.form.trackCompany;
          row.trackType = this.form.trackType;
          this.$http.post("basic", "ChangeAddress/setPrice", row)
            .then((resp) => {
              row.oldPrice = resp.oldPrice;
              row.newPrice = resp.newPrice;
            }).catch(() => {
              this.$message.error("运费计算出错");
            });
        }

      },

      updateRestPrice(row) {
        row.restPrice = row.newPrice - row.payedPrice - row.oldPrice;
      },

      updateVO() {
        this.updateLoading = true;
        this.$http.post("basic", "ChangeAddress/updateVO", this.form)
          .then((resp) => {
            this.form = resp;
            this.updateLoading = false;
          });
      },

      apply(row) {
        let detail = this.form.details.filter(item => item.factoryNo === row.factoryNo && (item.invoiceNo === null || item.invoiceNo === "") && item.status !== 1)[0];
        console.log(detail);
        if (detail === null) {
          this.$message.error("未找到匹配的行项");
        } else {
          detail.invoiceNo = row.invoiceNo;
          detail.shippingAddress = row.shippingAddress;
          detail.trackingNumber = row.carNo;
          detail.weight = row.weight;
        }
      },

      complete(row) {
        this.$http.get("basic", `ChangeAddress/updateDetailStatus/${row.pkid}`)
          .then(() => {
            this.$message.success("结单成功");
            row.status = 1;
          }).catch(() => {
            this.$message.error("结单失败");
          });
      },
    },
  };
</script>

<style>
.createDeliveryBillDialog .el-dialog__body {
  padding: 10px 20px;
}

.createDeliveryBillDialog .el-tabs__header {
  margin: 0 0 10px;
}


.disabled-select {
  pointer-events: none; /* 阻止点击事件 */
  opacity: 0.6; /* 降低透明度表示禁用状态 */
  background-color: #f5f5f5; /* 灰色背景 */
}

.messageBox {
  z-index: 9999 !important;
}
</style>
